import { TodoDescriptor } from '../../schema/TodoDescriptor';
import { GetTasksRequestParams, ExpandValue } from 'owa-todo-service';
import { getRequestTypeFromDescriptor } from './getRequestTypeFromDescriptor';
import { getFilterForDescriptor } from './getFilterForDescriptor';
import { getCustomQueryOptions } from './getCustomQueryOptions';
import { getOrderByValueForDescriptor } from './getOrderByValueForDescriptor';
import { isTodoFolderDescriptor } from '../typeGuards';

export function todoDescriptorToRequestParams(descriptor: TodoDescriptor): GetTasksRequestParams {
    return {
        type: getRequestTypeFromDescriptor(descriptor),
        filters: getFilterForDescriptor(descriptor),
        customQueryOptions: getCustomQueryOptions(descriptor),
        orderBy: getOrderByValueForDescriptor(descriptor),
        expand: ExpandValue.LinkedEntities,
        folderId: isTodoFolderDescriptor(descriptor) ? descriptor.folderId : undefined,
    } as GetTasksRequestParams;
}
